// @flow
import {combineReducers} from 'redux';
import {certificateReducer} from './certificate';
import type {TCertificateState} from './certificate';

const reducers = {
    certificate: certificateReducer,
};

type TCertificateModuleState = {
    certificate: TCertificateState,
};

const certificateModuleReducer = combineReducers(reducers);
export {certificateModuleReducer};
export type {TCertificateModuleState};
